// extracted by mini-css-extract-plugin
export var label = "_87-1";
export var reminder = "_87-0";